/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import SzczegolyEuslugi from './SzczegolyEuslugi';
import ServicesLayout from '../../../components/ServicesLayout';

/* eslint-disable global-require*/
export default {

  path: '/:prefix',

  action(ctx) {
    return {
      component: <ServicesLayout active="catalogue" ><SzczegolyEuslugi prefix={ctx.params.prefix}/></ServicesLayout>,
      description: "Inspire Hub - Platforma do publikacji danych przestrzennych dla gmin",
    };
  },
};



// WEBPACK FOOTER //
// src/routes/euslugi/szczegolyEuslugi/index.js